<template>
  <div></div>
</template>

<script>
import { Bus } from "../main";

export default {
  name: "FormStaticNT",
  props: {
    field: {
      type: Object,
    },
  },
  data() {
    return {
      metadata: this.field.metadata,
    }
  },
  mounted() {
    this.$el.innerHTML = this.metadata.content;

    Bus.$on("refreshStatic", (field) => {
      if (this.field.layout.seq === field.layout.seq) {
        this.metadata = field.metadata;
        this.$el.innerHTML = field.metadata.content;
      }
    })
  },
  beforeDestroy() {
    Bus.$off("refreshStatic");
  },
};
</script>

<style scoped>
</style>